export const LOGIN_LOGIN_BEGIN = 'LOGIN_LOGIN_BEGIN';
export const LOGIN_LOGIN_SUCCESS = 'LOGIN_LOGIN_SUCCESS';
export const LOGIN_LOGIN_FAILURE = 'LOGIN_LOGIN_FAILURE';
export const LOGIN_LOGIN_DISMISS_ERROR = 'LOGIN_LOGIN_DISMISS_ERROR';
export const LOGIN_CHANGE_ROLE = 'LOGIN_CHANGE_ROLE';
export const CHANGE_USER_NAME = 'CHANGE_USER_NAME';
export const LOGIN_GET_CODE_ACTION_BEGIN = 'LOGIN_GET_CODE_ACTION_BEGIN';
export const LOGIN_GET_CODE_ACTION_SUCCESS = 'LOGIN_GET_CODE_ACTION_SUCCESS';
export const LOGIN_GET_CODE_ACTION_FAILURE = 'LOGIN_GET_CODE_ACTION_FAILURE';
export const LOGIN_GET_CODE_ACTION_DISMISS_ERROR = 'LOGIN_GET_CODE_ACTION_DISMISS_ERROR';
export const LOGIN_GET_CODE_IMAGE_ACTIONS_BEGIN = 'LOGIN_GET_CODE_IMAGE_ACTIONS_BEGIN';
export const LOGIN_GET_CODE_IMAGE_ACTIONS_SUCCESS = 'LOGIN_GET_CODE_IMAGE_ACTIONS_SUCCESS';
export const LOGIN_GET_CODE_IMAGE_ACTIONS_FAILURE = 'LOGIN_GET_CODE_IMAGE_ACTIONS_FAILURE';
export const LOGIN_GET_CODE_IMAGE_ACTIONS_DISMISS_ERROR = 'LOGIN_GET_CODE_IMAGE_ACTIONS_DISMISS_ERROR';
export const LOGIN_LOGIN_ACTIONS_BEGIN = 'LOGIN_LOGIN_ACTIONS_BEGIN';
export const LOGIN_LOGIN_ACTIONS_SUCCESS = 'LOGIN_LOGIN_ACTIONS_SUCCESS';
export const LOGIN_LOGIN_ACTIONS_FAILURE = 'LOGIN_LOGIN_ACTIONS_FAILURE';
export const LOGIN_LOGIN_ACTIONS_DISMISS_ERROR = 'LOGIN_LOGIN_ACTIONS_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/login/redux/constants.js